import { Card } from 'sections/Events/components/EventCard/EventCard.types';

export const cardsData: Card[] = [
  {
    id: 4,
    registrationLink: 'https://crmmarketing.powerappsportals.com/dfallianceinvitepage/',
    pageLink: '/events/members-meeting',
    isOnline: false,
    imageSrc: '/images/pages/Events/MembersMeeting/card-image__desktop.webp',
    imageSrcTablet: '/images/pages/Events/MembersMeeting/card-image__tablet.webp',
    imageSrcMobile: '/images/pages/Events/MembersMeeting/card-image__mobile.webp',
    imageAlt: 'Digital Freight Members',
    priority: true,
    date: {
      month: 'May',
      days: '29.05.2025',
    },
    title: 'Monthly Members Meeting',
    list: [
      {
        img: '/images/main/eventsMain/4.svg',
        text: '29 May 2025',
      },
      {
        img: '/images/main/eventsMain/5.svg',
        text: 'Online meeting',
      },
    ],
    buttonTitle: 'Register',
  },
  {
    id: 6,
    registrationLink: `https://www.theglobalfreightsummit.com/event/2024/regProcessStep1:09ce1b97-373a-42d2-bb5b-6db904974f39?rt=Y2OM2JipKUKQ_o7j_ZKkYQ`,
    pageLink: '/events/global-freight-summit',
    isOnline: false,
    imageSrc: '/images/pages/Events/GlobalFreightSummit/card-image-2024__desktop.webp',
    imageSrcTablet: '/images/pages/Events/GlobalFreightSummit/card-image-2024__tablet.webp',
    imageSrcMobile: '/images/pages/Events/GlobalFreightSummit/card-image-2024__mobile.webp',
    imageAlt: 'Global Freight Summit',
    priority: false,
    date: {
      month: 'November',
      days: '18.11 - 20.11.2024',
    },
    title: 'Global Freight Summit 2024',
    list: [
      {
        img: '/images/main/eventsMain/4.svg',
        text: '18 November 2024 - 20 November 2024',
      },
      {
        img: '/images/main/eventsMain/5.svg',
        text: 'Expo City',
      },
      {
        text: 'Dubai, United Arab Emirates',
        link: 'https://www.google.com/maps/place/Expo+City+Dubai/@24.9608843,55.1506911,15z/data=!4m6!3m5!1s0x3e5f72d99893b4f9:0x53ca187a1bc8bfd5!8m2!3d24.9608843!4d55.1506911!16s%2Fg%2F11nn3rqztf?entry=ttu',
      },
    ],
    buttonTitle: 'Register',
  },
  {
    id: 5,
    registrationLink: '#',
    pageLink: '/blog/global-freight-summit-2023-by-dp-world-key-insights-and-impressions-from-dfa',
    isOnline: false,
    imageSrc: '/images/pages/Events/GlobalFreightSummit/card-image-2023__desktop.webp',
    imageSrcTablet: '/images/pages/Events/GlobalFreightSummit/card-image-2023__tablet.webp',
    imageSrcMobile: '/images/pages/Events/GlobalFreightSummit/card-image-2023__mobile.webp',
    imageAlt: 'Global freight summit card',
    priority: false,
    date: {
      month: 'November',
      days: '15.11 - 17.11.2023',
    },
    title: 'Global Freight Summit 2023',
    list: [
      {
        img: '/images/main/eventsMain/4.svg',
        text: '15 November 2023 - 17 November 2023',
      },
      {
        img: '/images/main/eventsMain/5.svg',
        text: 'Coca Cola Arena, Dubai',
      },
      {
        text: 'Dubai, United Arab Emirates',
        link: 'https://www.google.com/maps/place//@24.9633625,55.1558468,15z?entry=ttu',
      },
    ],
    buttonTitle: 'More details',
  },
  {
    id: 3,
    registrationLink: '#',
    pageLink: '/blog/global-freight-summit-2022-by-dp-world-key-insights-and-thoughts-from-df-alliance',
    isOnline: false,
    imageSrc: '/images/pages/Events/GlobalFreightSummit/card-image__desktop.webp',
    imageSrcTablet: '/images/pages/Events/GlobalFreightSummit/card-image__tablet.webp',
    imageSrcMobile: '/images/pages/Events/GlobalFreightSummit/card-image__mobile.webp',
    imageAlt: 'DP World logo',
    priority: false,
    date: {
      month: 'November',
      days: '14.11 - 16.11.2022',
    },
    title: 'Global Freight Summit 2022',
    list: [
      {
        img: '/images/main/eventsMain/4.svg',
        text: '14 November 2022 - 16 November 2022',
      },
      {
        img: '/images/main/eventsMain/5.svg',
        text: 'Grand Hyatt',
      },
      {
        text: 'Dubai, United Arab Emirates',
        link: 'https://www.google.com/maps/place/Grand+Hyatt+Dubai/@25.2278443,55.3255064,17z/data=!4m19!1m9!3m8!1s0x3e5f5d46f88c69a3:0xbdd27b1c33c3af0d!2sGrand+Hyatt+Dubai!5m2!4m1!1i2!8m2!3d25.2281726!4d55.3279045!3m8!1s0x3e5f5d46f88c69a3:0xbdd27b1c33c3af0d!5m2!4m1!1i2!8m2!3d25.2281726!4d55.3279045!15sChFHcmFuZCBIeWF0dCBEdWJhaSIDiAEBWhMiEWdyYW5kIGh5YXR0IGR1YmFpkgEFaG90ZWyaASNDaFpEU1VoTk1HOW5TMFZKUTBGblNVUk5lRkJ0YjFwQkVBReABAA',
      },
    ],
    buttonTitle: 'More details',
  },
  {
    id: 2,
    registrationLink:
      'https://www.youtube.com/watch?v=fRpK-6Ck9AY&feature=youtu.be&ab_channel=DigitalFreightAlliancebyDPWorld',
    pageLink: '/events/future-of-freight',
    isOnline: true,
    imageSrc: '/images/pages/Events/FutureOfFreight/card-image__desktop.webp',
    imageSrcTablet: '/images/pages/Events/FutureOfFreight/card-image__tablet.webp',
    imageSrcMobile: '/images/pages/Events/FutureOfFreight/card-image__mobile.webp',
    imageAlt: 'DF Alliance meeting',
    priority: false,
    date: {
      month: 'July',
      days: '19.07.2022',
    },
    title: 'DFA Conference on Digitalization and the Future of Freight',
    list: [
      {
        img: '/images/main/eventsMain/4.svg',
        text: '19 July 2022, 15:00 UTC+7 (GMT+7)',
      },
      {
        img: '/images/main/eventsMain/5.svg',
        text: 'Bangkok, Thailand',
      },
      {
        text: 'Venue - Marriott Marquis Queen’s Park',
        link: 'https://www.google.com/maps/contrib/112411754511611996893/place/ChIJDf7QWt2e4jAR9f2xgL5R6KM/@15.6608519,97.2845105,5z/data=!4m6!1m5!8m4!1e2!2s112411754511611996893!3m1!1e1',
      },
    ],
    buttonTitle: 'Follow online',
  },
  {
    id: 1,
    registrationLink: '#',
    pageLink: '/events/1st-dfa-annual-conference',
    isOnline: false,
    imageSrc: '/images/main/eventsMain/1_1.webp',
    imageSrcTablet: '/images/main/eventsMain/1_2.webp',
    imageSrcMobile: '/images/main/eventsMain/1_3.webp',
    imageAlt: 'DP World Company',
    priority: false,
    date: {
      month: 'March',
      days: '10.03. — 11.03.2022',
    },
    title: 'Digital Freight Alliance Annual Members Meeting',
    list: [
      {
        img: '/images/main/eventsMain/4.svg',
        text: '10 March 2022 — 11 March 2022',
      },
      {
        img: '/images/main/eventsMain/5.svg',
        text: 'DP World Flow Pavilion at Expo 2020',
      },
      {
        text: 'Dubai, United Arab Emirates',
        link: 'https://www.google.com.ua/maps/place/%D0%94%D1%83%D0%B1%D0%B0%D0%B9+-+%D0%9E%D0%B1%D1%8A%D0%B5%D0%B4%D0%B8%D0%BD%D0%B5%D0%BD%D0%BD%D1%8B%D0%B5+%D0%90%D1%80%D0%B0%D0%B1%D1%81%D0%BA%D0%B8%D0%B5+%D0%AD%D0%BC%D0%B8%D1%80%D0%B0%D1%82%D1%8B/@25.0620108,54.798968,8.4z/data=!4m5!3m4!1s0x3e5f43496ad9c645:0xbde66e5084295162!8m2!3d25.2048493!4d55.2707828?hl=ru',
      },
    ],
    buttonTitle: 'More details',
  },
];